/**
 * Global console filter to suppress noisy third-party SDK logs
 * while preserving error messages for debugging
 */

// Store original console methods
const originalLog = console.log;
const originalWarn = console.warn;
const originalInfo = console.info;

// Patterns to filter out (third-party SDK noise)
const FILTER_PATTERNS = [
  />>>JSPlayerInterface/,
  /wasmplayer\.min\.js version/,
  /there will play by V[0-9]/,
  /your browser protocol is/,
  /Decoder\.js loaded path/,
  /PlayM4_/,
  /StreamSource\.cpp/,
  /decodeEngine is/,
  /webgl render/,
  /hard decoder/,
  /hardThread success/,
  /websocket onclose e\.code/,
  /totalWasmMemory/,
  /JSPlayCtrl oJSPlayerWasm/,
  /MaxListenersExceededWarning/,
];

/**
 * Check if a log message should be filtered
 */
function shouldFilter(args: any[]): boolean {
  const message = args.map(arg => 
    typeof arg === 'string' ? arg : JSON.stringify(arg)
  ).join(' ');
  
  return FILTER_PATTERNS.some(pattern => pattern.test(message));
}

/**
 * Initialize console filtering
 */
export function initConsoleFilter() {
  // Override console.log
  console.log = function(...args: any[]) {
    if (!shouldFilter(args)) {
      originalLog.apply(console, args);
    }
  };

  // Override console.warn
  console.warn = function(...args: any[]) {
    if (!shouldFilter(args)) {
      originalWarn.apply(console, args);
    }
  };

  // Override console.info
  console.info = function(...args: any[]) {
    if (!shouldFilter(args)) {
      originalInfo.apply(console, args);
    }
  };

  // Keep console.error untouched for debugging
  // console.error stays as-is
}

/**
 * Restore original console methods (for testing/debugging)
 */
export function restoreConsole() {
  console.log = originalLog;
  console.warn = originalWarn;
  console.info = originalInfo;
}
